import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Flex,
  Image,
  Box,
  Text,
} from "@chakra-ui/react";
import Arrow from "./images/arrow.svg";
import ArrowOpen from "./images/arrow_open.svg";
import { useState } from "react";

const CommonMenu = ({ menuList, isCollapse, ItemCmp, menuLabel }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      onMouseEnter={() => {
        isCollapse && setIsOpen(true);
      }}
      onMouseLeave={() => {
        isCollapse && setIsOpen(false);
      }}
    >
      <Menu isOpen={isCollapse ? isOpen : undefined} autoSelect={false}>
        {({ isOpen }) => (
          <div>
            <MenuButton
              px={"8px"}
              h={"32px"}
              borderRadius={"20px"}
              color={"gray.light"}
              _hover={{
                background: "gray.sombre",
                color: "brand",
              }}
              _expanded={{
                background: "gray.sombre",
                color: "brand",
              }}
            >
              <Flex alignItems={"center"}>
                <Text fontSize={"14px"} verticalAlign={"middle"}>
                  {menuLabel}
                </Text>
                <Image
                  w={"16px"}
                  h={"16px"}
                  mt={"4px"}
                  src={isOpen ? ArrowOpen : Arrow}
                  sx={{
                    transform: isOpen ? "rotateX(180deg)" : "none",
                  }}
                />
              </Flex>
            </MenuButton>

            <MenuList
              color="white"
              zIndex={101}
              bgColor={"gray.desolate"}
              border="none"
              p={"12px"}
              borderRadius={"16px"}
              minWidth="0"
              fontSize="sm"
              mt={isCollapse ? "6px" : 0}
              ml={isCollapse ? "-16px" : 0}
            >
              {menuList.map(({ onClick, ...other }) => (
                <MenuItem
                  borderRadius={"8px"}
                  _hover={{
                    background: "#131A24",
                  }}
                  _focus={{
                    background: "transparent",
                  }}
                  onClick={onClick}
                  p={"12px"}
                >
                  <ItemCmp {...other} />
                </MenuItem>
              ))}
            </MenuList>
          </div>
        )}
      </Menu>
    </Box>
  );
};

const DrawerMenu = ({ menuList, ItemCmp, menuLabel }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box cursor={"pointer"} w={"full"}>
      <Flex
        h={"48px"}
        alignItems={"center"}
        justifyContent={"space-between"}
        _hover={{
          background: "#131A24",
          color: "theme.light",
        }}
        background={isOpen ? "#131A24" : ""}
        onClick={() => setIsOpen(!isOpen)}
        px="24px"
      >
        <Text fontSize={"14px"} verticalAlign={"middle"}>
          {menuLabel}
        </Text>
        <Image
          w={"16px"}
          h={"16px"}
          mt={"4px"}
          src={isOpen ? ArrowOpen : Arrow}
          sx={{
            transform: isOpen ? "rotateX(180deg)" : "none",
          }}
        />
      </Flex>

      {isOpen ? (
        <Box px="24px">
          {menuList.map(({ onClick, ...other }) => (
            <Flex
              borderRadius={"8px"}
              _hover={{
                // background: "#131A24",
                color: "theme.light",
              }}
              onClick={onClick}
              p={"12px"}
            >
              <ItemCmp {...other} />
            </Flex>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

const TheMenu = ({ inDrawer, ...props }) => {
  if (inDrawer) return <DrawerMenu {...props} />;

  return <CommonMenu {...props} />;
};

export default TheMenu;
